


import { useMemo, useState } from "react";
import { enqueueSnackbar } from "notistack";

import { Box, Stack } from "@mui/system";
import { LoadingButton } from "@mui/lab";
import { Alert, Typography } from "@mui/material";

import { useRouter } from "src/routes/hooks";

import { useAuthContext } from "src/hooks/auth/use-auth-context";

import { useTranslate } from "src/locales";
import { EmailConnectionStatus } from "src/services/email-sync/email-sync.types";
import { useGetEmailConnectionStateQuery, useInitiateEmailConnectionMutation } from "src/services/email-sync/email-sync.service";

import Iconify from "src/components/iconify";

import { TenantType } from "src/types/enums";

export default function EmailSyncAlert() {

  const { t } = useTranslate();

  const authContext = useAuthContext();

  const router = useRouter();

  const [loading, setLoading] = useState(false);

  const { currentData: connectionState } = useGetEmailConnectionStateQuery();
  const [initiateEmailConnection] = useInitiateEmailConnectionMutation();

  const shouldShowAlert = useMemo(() => {
    if (![TenantType.Client, TenantType.Recruiter].includes(authContext.account.type)) return false;
    if (!connectionState) return false;

    if (connectionState.status === EmailConnectionStatus.EXPIRED) {
      return true;
    }

    return false;

  }, [connectionState, authContext]);


  const handleInitiateConnect = async () => {
    try {
      setLoading(true);
      const response = await initiateEmailConnection().unwrap();
      window.location.href = response.url;
    } catch (error) {
      setLoading(false);
      enqueueSnackbar(t('account.email-connection.api.connect.default_error'), { variant: 'error' });
    }
  };

  if (!shouldShowAlert) return null;

  return (
    <Box sx={{ width: '100%', p: .5 }}>
      <Alert
        severity='warning'
        sx={{ mb: 2, width: "100%" }}
        action={
          <LoadingButton
            loading={loading}
            variant="contained"
            size="small"
            sx={{ mt: 1 }}
            endIcon={<Iconify icon='material-symbols:lock-reset-rounded' />}
            onClick={handleInitiateConnect}
          >
            {t('email_sync.expired_alert.button')}
          </LoadingButton>
        }
      >
        <Stack direction='column' gap={0} alignItems='start' flexGrow={1}>
          <Typography variant='subtitle2'>
            {t('email_sync.expired_alert.title')}
          </Typography>
          <Typography variant='caption'>
            {t('email_sync.expired_alert.subtitle')}
          </Typography>
        </Stack>

      </Alert >
    </Box>
  )
}